import { EMPTY_OBJECT } from '../../../constants/common'
import {
  BIRDVIEW_REQUEST_REASON_HINT_KEY,
  BirdviewRequestAction,
} from '../DashboardBirdview.constants'

// Overdue, due today and unknown reasons keep the deadline text.
function getBirdviewRequestReasonHint({
  reason: { days, key } = EMPTY_OBJECT,
  t,
}) {
  const hintKey = BIRDVIEW_REQUEST_REASON_HINT_KEY[key]

  return hintKey ? t(hintKey, { count: days }) : undefined
}

export function checkIsBirdviewAssignAction(action) {
  return action === BirdviewRequestAction.Assign
}

export function getBirdviewRequestAction({ assignee, isInteractive, item }) {
  return isInteractive && !assignee && item.canEditAssignee
    ? BirdviewRequestAction.Assign
    : BirdviewRequestAction.Open
}

export function getBirdviewRequestDeadlineMetaProps({ item, t }) {
  return {
    deadline: item.deadline,
    hint: getBirdviewRequestReasonHint({ reason: item.reason, t }),
  }
}

export function getBirdviewRequestUpdatedMetaProps({ item }) {
  return { date: item.updated }
}
